import { render, staticRenderFns } from "./FormOfThree.vue?vue&type=template&id=4cbd962c&scoped=true&"
import script from "./FormOfThree.vue?vue&type=script&lang=js&"
export * from "./FormOfThree.vue?vue&type=script&lang=js&"
import style0 from "./FormOfThree.vue?vue&type=style&index=0&id=4cbd962c&lang=less&scoped=true&"
import style1 from "./FormOfThree.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cbd962c",
  null
  
)

export default component.exports